import { NewTicketForm } from './FormMobile/NewTicketForm'

const NewTicket = () => (
  <>
    <NewTicketForm />
  </>
)

export { NewTicket }
